// extracted by mini-css-extract-plugin
export default {"PrintedBomIFrameWrapper":"printedBom-module_PrintedBomIFrameWrapper_WEahr","PrintedBomIFrame":"printedBom-module_PrintedBomIFrame_sKAH8"};